import { createContext } from 'react';
const initialContext = {
    isLoading: true,
    roles: [],
    reload: () => Promise.resolve(),
};
export const RolesContext = createContext(initialContext);
